import axios from "axios";

const dataSourcesExploreApi = {
  fetchCdes: (id, page = 1, per = 1000, search = "") =>
    axios.get(
      `/api/v1/data_sources_explore/${id}/cde_definitions?page=${page}&per_page=${per}&search=${search}`
    ),
  associateCdes: (id, payload) =>
    axios.post(`/api/v1/data_sources_explore/${id}/cde_definitions/associate`, {
      cde_definition: payload,
    }),
  fetchDomains: (id, page = 1, per = 1000, search = "") =>
    axios.get(
      `/api/v1/data_sources_explore/${id}/domains?page=${page}&per_page=${per}&search=${search}`
    ),
  associateDomains: (id, payload) =>
    axios.post(`/api/v1/data_sources_explore/${id}/domains/associate`, {
      domain: payload,
    }),
  fetchReferenceSources: (id, page = 1, per = 1000, search = "") =>
    axios.get(
      `/api/v1/data_sources_explore/${id}/reference_sources?page=${page}&per_page=${per}&search=${search}`
    ),
  associateReferenceSources: (id, payload) =>
    axios.post(
      `/api/v1/data_sources_explore/${id}/reference_sources/associate`,
      {
        reference_source: payload,
      }
    ),
  fetchBusinessTerms: (id, page = 1, per = 1000, search = "") =>
    axios.get(
      `/api/v1/data_sources_explore/${id}/business_terms?page=${page}&per_page=${per}&search=${search}`
    ),
  associateBusinessTerms: (id, payload) =>
    axios.post(`/api/v1/data_sources_explore/${id}/business_terms/associate`, {
      business_term: payload,
    }),
};

export default dataSourcesExploreApi;
